  <template>
  <div>
    <v-row class="mx-4">
      <v-col cols="12" md="9">
        <h2 class="text-left">Leave Record</h2>
      </v-col>
      <v-col cols="12" md="3" v-if="currentUser.privileges.CanViewAllStaffLeaveAccounts">
        <v-btn color="primary" block :to="{ name: 'StaffLeaveAccounts' }">Staff Leave Accounts</v-btn>
      </v-col>
    
    </v-row>
       
    <v-card class="pa-2 ma-3">
       <v-card-title>
          All Staff Leaves
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
            <download-excel
            v-if="currentUser.privileges.canExportAllStaffsLeaveRecords"
          :fetch="getExportData"
          :fields="export_fields"
          :name="getExportName"
        >
          <v-btn
            class="ml-3 text-right"
            :loading="export_in_progress"
            :disabled="export_in_progress"
            color="white"
            elevation="1"
          >
            Export
            <v-icon right dark> mdi-export </v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </download-excel>
          </v-card-title>
      <v-row class="py-1">
        <v-col cols="12" md="4">
          <h2 class="text-left px-2 font-weight-medium"></h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="end" class="mx-3">
        <v-col cols="12" md="4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="filter.dateRange"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedDateRange"
                label="Date Range"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                class="rounded-input"
                outlined
                dense
                clearable
                @click:clear="clearRangeAndQueryLeaves()"
              ></v-text-field>
            </template>
            <v-date-picker
              @change="getAllStaffLeaves"
              v-model="filter.dateRange"
              no-title
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(filter.dateRange)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-col>

       

        <v-col cols="12" md="4">
          <v-select
            v-model="filter.leaveType"
            :items="allLeaveTypes"
            small-chips
            outlined
            color="primary"
            label="Filter by Leave Type"
            multiple
            hide-details
            dense
            background-color="transparent"
            item-value="id"
            item-text="title"
            class="mb-4 rounded-input"
            @change="getAllStaffLeaves()"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="filter.status"
            :items="allStatuses"
            small-chips
            outlined
            color="primary"
            label="Filter by Status"
            hide-details
            dense
            background-color="transparent"
            item-value="value"
            return-object
            item-text="status"
            multiple
            class="mb-4 rounded-input"
            @change="getAllStaffLeaves()"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="leaveRecords"
        :multi-sort="true"
        v-model="selected"
        :search="search"
        class="row-pointer"
        disable-pagination
        :options.sync="options"
        :items-per-page="15"
        :server-items-length="pagination.totalCount"
        @click:row="clickAttendanceRow"

      >

         <template v-slot:item.name="{ item }">
             <h5>{{item.name}} </h5>
         </template>
         <template v-slot:item.start_date="{ item }">
             <span>{{moment(item.start_date).format('LL')}}</span>
         </template>
         <template v-slot:item.end_date="{ item }">
             <span>{{moment(item.end_date).format('LL')}}</span>
         </template>

        <!-- total students stats display -->
        <template v-slot:item.approved="{ item }">
          <v-chip :color="item.approved ? 'green' : item.approved === false ? 'red' : 'orange' " small class="px-5 py-3" dark outlined>
            <h4>{{ item.approved ? 'Approved' : item.approved === false ? 'Rejected' : 'Pending' }}</h4>
          </v-chip>
        </template>

      </v-data-table> 
    </v-card>

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import JsonExcel from "vue-json-excel";
import Helper from "@utils/misc";
import TourHelper from "@utils/tour_helper";


export default {
  name: "StaffLeaveRecord",

  data() {
    return {
      menu: false,
      search: "",
      options: {},
      filter: {
        status: null,
        leaveType: null,
        dateRange: null,
      },
      pagination: {
        totalCount: 0,
        url: endpoints.staffLeaves,
      },
      snackbar: {
        visible: false,
        text: "",
      },
      moment: moment,
      // singleSelect: false,
      selected: [],
      headers: [
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "staff.full_name"
        },
        {
          text: "Start Date",
          align: "center",
          sortable: true,
          value: "start_date"
        },
        {
          text: "End Date",
          align: "center",
          sortable: true,
          value: "end_date"
        },
        {
          text: "Leave Type",
          align: "center",
          sortable: true,
          value: "leave_type.title"
        },
        {
          text: "Duration",
          align: "center",
          sortable: false,
          value: "duration"
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "approved"
        },
      ],
      leaveRecords: [],
      allLeaveTypes: [],
      allStatuses: [
        {
          "status": "Pending",
          "value": "None"

        },
        {
          "status": "Approved",
          "value": "True"

        },
        {
          "status": "Rejected",
          "value": "False"

        }        
      ],
      
      export_in_progress: false,
      export_fields: {
        "Full Name": "staff.full_name",
        "Start Date": "start_date",
        "End Date": "end_date",
        "Leave Type": "leave_type.title",
        "Duration": "duration",
        "Requested On": {
          field: "requested_on",
          callback: (value) => {
            if (!value) return "";
            return this.moment(value).format("LL");
          }
        },
        "Status" : {
          field: "approved",
          callback: (value) => {
            if(value == true) return "Approved";
            else if(value == false) return "Rejected";
            else "Pending";
          }
        },
        "Paid/Unpaid": {
          field: "is_paid",
          callback: (value) => value ? "Paid" : "Unpaid",
        },
        "Approver/Rejector": "acted_by.full_name",
        "Acted On": {
          field: "acted_on",
          callback: (value) => {
            if (!value) return "";
            return this.moment(value).format("LL");
          }
        },
        "Reason": "reason",
      },

    };
  },
  components: {
        downloadExcel: JsonExcel,
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
     getExportName() {
      return Helper.getExportName();
    },
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
    formattedDateRange() {
      if (!this.filter.dateRange) return;
      if(this.filter.dateRange.length == 1) return moment(this.filter.dateRange[0]).format("LL") + " -";
      var formatted =
        moment(this.filter.dateRange[0]).format("D MMM, YYYY") +
        " - " +
        moment(this.filter.dateRange[1]).format("D MMM, YYYY");
      return formatted;
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Leave Records", description: "View all your applied,approved or rejected leaves in this section", videoLink: "https://youtube.com"});
        // steps.push({id: '2', description: "After Selecting classroom and date, click on fetch to take and edit attendance", el: '#fetch'});
        TourHelper.startTour(this, "leave__record", steps);
    },

    // api call to get attendance records for the class
    async getAllStaffLeaves() {
      var url = this.pagination.url;
      if (this.search) {
        url = Helper.addUrlParams(url, "q=" + this.search);

      }

      if(this.filter.status) {
        url = Helper.addUrlParams(url, "status=" + this.filter.status.map((s) => s.value));
      }

      if(this.filter.dateRange && this.filter.dateRange.length == 2) {
        url = Helper.addUrlParams(url, "range=" + this.filter.dateRange)
      }

      if(this.filter.leaveType) {
        url = Helper.addUrlParams(url, "type=" + this.filter.leaveType);
      }

      var response = await api.call(this.apiEssentials, url);
      if(response){
        this.leaveRecords = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      }
      console.log(response);
    },

    async getAllLeaveTypes() {
      this.allLeaveTypes = await api.call(this.apiEssentials, endpoints.staffLeaveTypes);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
    
    async clearRangeAndQueryLeaves() {
      this.filter.dateRange = [];
      this.getAllStaffLeaves()
    },


    async getExportData() {
      this.export_in_progress = true;
      var url = this.pagination.url;
      if (this.search) {
        url = Helper.addUrlParams(url, "q=" + this.search);

      }

      if(this.filter.status) {
        url = Helper.addUrlParams(url, "status=" + this.filter.status.map((s) => s.value));
      }

      if(this.filter.dateRange && this.filter.dateRange.length == 2) {
        url = Helper.addUrlParams(url, "range=" + this.filter.dateRange)
      }

      if(this.filter.leaveType) {
        url = Helper.addUrlParams(url, "type=" + this.filter.leaveType);
      }

      url = Helper.addUrlParams(url, 'export=true');

      var response = await api.call(this.apiEssentials, url);

      if (response) {
        this.export_in_progress = false;
        return response;
      }
    },

    // redirect to class-specific attendance details page
    clickAttendanceRow(value) {
      this.$router.push({ name: "LeaveDetails", query: { 'staff_id': value.staff.id }, params: { month: moment(value.start_date).month() + 1, year: moment(value.start_date).year() } });
    },

    
  },

  watch: {
    options: {
      async handler() {
        this.pagination.url =
          endpoints.staffLeaves + "?page=" + this.options.page;
        if (this.options.sortBy.length > 0) {
          // get url var
          var params = "&o=";
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }

          params = Helper.replaceTextFromArray(params, [['staff.full_name', 'staff__full_name'], ['leave_type.title','leave_type__title']]);

          // if(params.includes('staff.full_name')){
          //   params = params.replace('staff.full_name','staff__full_name')
          // }

          // if(params.includes('staff.leave_type')){
          //   params = params.replace('staff.leave_type','staff__leave_type')
          // }

          this.pagination.url += params;
          this.export_url += params;
        } 
        this.getAllStaffLeaves();
      },
    },
    search: {
      async handler() {
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getAllStaffLeaves();
          }
        }, 500);
      },
    },
  },
  
  created() {
    this.getAllStaffLeaves();
    this.getAllLeaveTypes();
    this.handleTour();
  },
};
</script>


<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;
  color: #000000;
  vertical-align: middle;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
